import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// JWT is sent via Authorization header (set per-request in auth.jsx), not cookies.
// Setting withCredentials:true would force the backend to use a non-wildcard
// Access-Control-Allow-Origin and break CORS on the deployed site.
export const api = axios.create({
  baseURL: API,
});
